import { useMessage } from "@hermes/intl";
import { useMemo } from "react";

export const CHILDREN_AGES = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 24, 36, 48, 60, 72, 84, 96, 108,
  120, 132, 144, 156, 168, 180, 192, 204, 216,
];

export const useChildrenAgeOptions = () => {
  const message = useMessage();
  return useMemo(
    () =>
      CHILDREN_AGES.map((age) => ({
        value: age,
        label:
          age > 0 && age % 12 === 0
            ? message({
                id: "056e12c9-1084-4fff-a449-4664cad9d4ae",
                default:
                  "{age} {age, plural, one {год} few {года} other {лет}}",
                values: { age: age / 12 },
              })
            : message({
                id: "7cbd3ef0-df27-43f3-a691-af86ae743591",
                default:
                  "{age} {age, plural, one {месяц} few {месяца} other {месяцев}}",
                values: { age },
              }),
      })),
    [message],
  );
};
